export interface cv_JobReport {
    C_JobReport_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    JobReport: string;
    ModifiedBy: string;
    SortOrder: number | null;
    Version: number;
}
